import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  lang: string = '';

  constructor(private translate: TranslateService , @Inject(PLATFORM_ID) private _platformId:Object) {
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.lang = params.lang;
    });
  }

   redirectToExternalURL(url:string) {
      if(isPlatformBrowser(this._platformId)){
       window.open(url,"_blank") 
      }
    }
  

}
